import { AwsUi } from '../../../../core/runtime/src';
import { Button } from '../../../button/src';
import { renderMonthAndYear } from './utils/intl';
var HeaderButton = function (_a) {
    var label = _a.label, onChangeMonth = _a.onChangeMonth, isPrevious = _a.isPrevious, focusable = _a.focusable;
    var icon = isPrevious ? 'angle-left' : 'angle-right';
    var className = "awsui-calendar__button awsui-calendar__button--" + (isPrevious ? 'previous' : 'next');
    var click = function (e) {
        e.preventDefault();
        onChangeMonth(isPrevious);
    };
    return (AwsUi.__createElement(Button, { variant: "icon", icon: icon, label: label, click: click, className: className, __tabindex: focusable ? 0 : -1 }));
};
export default (function (_a) {
    var baseDate = _a.baseDate, locale = _a.locale, onChangeMonth = _a.onChangeMonth, nextMonthLabel = _a.nextMonthLabel, previousMonthLabel = _a.previousMonthLabel, calendarHasFocus = _a.calendarHasFocus;
    return (AwsUi.__createElement("div", { className: "awsui-calendar__header" },
        AwsUi.__createElement(HeaderButton, { focusable: calendarHasFocus, isPrevious: true, label: previousMonthLabel, onChangeMonth: onChangeMonth }),
        AwsUi.__createElement("div", { className: "awsui-calendar__header-month", "aria-live": "polite" }, renderMonthAndYear(locale, baseDate)),
        AwsUi.__createElement(HeaderButton, { focusable: calendarHasFocus, isPrevious: false, label: nextMonthLabel, onChangeMonth: onChangeMonth })));
});
//# sourceMappingURL=header.js.map